export { default } from "./LinkCard"
